@if (isHandset()) {
<mat-icon
  role="button"
  tabindex="0"
  aria-label="Open search with Enter or Space, or use the shortcut ⌘ K while anywhere else in the page."
  (click)="openSearchModal()"
  (keydown.enter)="openSearchModal()"
  (keydown.space)="openSearchModal()"
  >search</mat-icon
>
} @else {
<div
  role="button"
  tabindex="0"
  class="header-search"
  aria-label="Search JTMS ⌘ K. Press Enter or Space to open, or use the shortcut ⌘ K anywhere on the page."
  (click)="openSearchModal()"
  (keydown.enter)="openSearchModal()"
  (keydown.space)="openSearchModal()"
>
  <svg
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    fill="currentColor"
    viewBox="0 0 32 32"
    aria-hidden="true"
    class="icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"></path>
  </svg>
  <span class="placeholder">Search JTMS</span>
  <span class="shortcut">⌘ K</span>
</div>
}
